export default __webpack_public_path__ + "static/media/about16.a34cf86b.jpeg";